import React from 'react'
import HeaderArea from '../HeaderArea'
import CollectorsRowHeading from './CollectorsRowHeading'
import CollectorsRowData from './CollectorsRowData'
import './FullTopCollectors.css'

function FullTopCollectors() {
    return (
        <div className="TopCollectors">
            <HeaderArea
                title = "Top Collectors"
            />
            <div className="dataTable">
                <table>
                    <CollectorsRowHeading
                        Collector = "Collector"
                        WorksCollected = "Works Collected"
                        WorksOwned = "Works Owned"
                        AvgPurchasePrice = "Avg. Purchase Price"
                        TotalPurchases = "Total Purchases"
                        BiggestPurchase =  "Biggest Purchase"
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                    <CollectorsRowData
                        Collector = "@username"
                        CollectorThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                        WorksCollected = {19}
                        WorksOwned = {19}
                        AvgPurchasePrice = {5,432}
                        TotalPurchases = {98,473}
                        BiggestPurchase = {16,873}
                    />
                </table>
            </div>
        </div>
    )
}

export default FullTopCollectors
